<template>
    <datatables-component
        table_id="terminal_cargos_table"
        :headers_json="cargo_headers"
        sort_key="terminal_cargos.created_at"
        sort_dir="desc"
        :filter_header="false"
        :data_url="data_url"
        :skip_sorting_header="true"
        :pagination="false">
        <template #goods="{ data, header }">
            <td :class="[header.cell_classes]">
                <div data-toggle="modal" :data-target="'#list_goods_modal_' + data.id" class="list-goods-modal" :data-cargo-id="data.id">{{ goods_trans }} <div class="goods-count-div">{{ data.goods_count }}</div></div>
            </td>
            <goods-modal-component 
                :cargo_id="data.id"
                :goods_trans="goods_trans"
                :assigned_goods_trans="assigned_goods_trans"
                :goods_header="goods_header"
                :goods_table_route="goods_table_route + data.id"
                :is_cargo_unconfirmed="data.is_cargo_unconfirmed"
                :assign_checked_trans="assign_checked_trans"
                :cargo_goods_header="cargo_goods_header"
                :cargo_goods_route = "cargo_goods_route + data.id"
                :update_quantities_trans = "update_quantities_trans"
                :assigned_goods_count = "data.goods_count"
                :departure="departure"
                :cargo_goods_pivot_header="cargo_goods_pivot_header"
                :show_goods="show_goods"
            >
            </goods-modal-component>
        </template>
    </datatables-component>
</template>

<script>
export default {
    props: {
        'departure': {
            'type': Boolean,
            'required': false,
            'default': false,
        },
        'assigned_goods_count': {
            'type': String,
            'required': false,
        },
        'update_quantities_trans': {
            'type': String,
            'required': true,
        },
        'cargo_goods_route': {
            'type': String,
            'required': true,
        },
        'cargo_goods_header': {
            'type': String,
            'required': true,
        },
        'cargo_goods_pivot_header': {
            'type': String,
            'required': true,
        },
        'assign_checked_trans': {
            'type': String,
            'required': true,
        },
        'goods_table_route': {
            'type': String,
            'required': true,
        },
        'goods_header': {
            'type': String,
            'required': true,
        },
        'assigned_goods_trans': {
            'type': String,
            'required': true,
        },
        'goods_trans': {
            'type': String,
            'required': true,
        },
        'cargo_headers': {
            'type': String,
            'required': true,
        },
        'data_url': {
            'type': String,
            'required': true,
        },
        'show_goods': {
            'type': Boolean,
            'required': false,
            'default': true,
        },
    },
}
</script>
